module.exports = __webpack_public_path__ + "media/images/tick-5687544bc5570822bba6d19b8d3b8107.svg";